import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { TextStyle } from "@rentiohq/web-shared/dist/components";
import * as S from "../../TenantProfileNotificationPreferences.styles";
import {
  getVariableDescription,
  INotificationVariable,
} from "./NotificationVariables.utils";

interface IProps {
  variables: INotificationVariable[];
  /** A last line under the list, such as what a missing value does. */
  footnote?: string;
}

/**
 * The variables the text of this tab may use, in a grey box beside the boxes
 * the office writes in (DEV-3553). Every one of them shows, one row each, so
 * the office reads it as a list it can pick from (Jonas, 2026-10-31).
 */
export const NotificationVariables = (props: IProps) => {
  const { variables, footnote } = props;

  const hasRequired = variables.some(variable => variable.isRequired);

  return (
    <S.VariablesBox>
      <TextStyle variation="strong" size="small">
        {getLocalizedText("tenant_profile.notification.variables.title")}
      </TextStyle>

      <S.VariableList>
        {variables.map(({ name, isRequired }) => (
          <S.VariableRow key={name}>
            <TextStyle variation="code" size="small">
              {`{{${name}}}${isRequired ? "*" : ""}`}
            </TextStyle>
            <TextStyle variation="subdued" size="small">
              {getVariableDescription(name)}
            </TextStyle>
          </S.VariableRow>
        ))}
      </S.VariableList>

      {(hasRequired || footnote) && (
        <div style={{ marginTop: "8px" }}>
          <TextStyle variation="subdued" size="small">
            {[
              hasRequired
                ? getLocalizedText(
                    "tenant_profile.notification.variables.required",
                  )
                : undefined,
              footnote,
            ]
              .filter(Boolean)
              .join(" ")}
          </TextStyle>
        </div>
      )}
    </S.VariablesBox>
  );
};
